<template>
  <div class="container main-content article-content">
    <div class="row section--profile-edit">
      <div class="col-lg-7">
        <span class="title">Basic</span>
        <div class="form-block form-upload form-block--attachments">
          <div class="box-user-img" v-if="!uploading">
            <ImageWrapper :file="$store.getters.user.idPicture"></ImageWrapper>
          </div>
          <div class="loading-avatar" v-if="uploading">
            <ImageLoader></ImageLoader>
          </div>
          <div class="button-group">
            <label for="add-new-attachment" class="link-icon d-none d-lg-inline-flex"><i class="icon-upload"></i> Upload new profile photo or drag file here</label>
            <label for="add-new-attachment" class="button-icon d-lg-none">Upload profile picture <i class="icon-img"></i></label>
            <input type="file" id="add-new-attachment" name="add-new-attachment" ref="file" v-on:change="uploadAvatar()">
            <div class="form-error"></div>
          </div>
        </div>

<!--        <div class="form-block&#45;&#45;switcher d-lg-none">-->
<!--          <div class="label">New joiner view</div>-->
<!--          <input type="checkbox" id="newjoiner">-->
<!--          <label class="switcher" for="newjoiner">-->
<!--            <span>On</span>-->
<!--            <div class="switcher-bg"><div class="switcher-indicator"></div></div>-->
<!--            <span>Off</span>-->
<!--          </label>-->
<!--        </div>-->

        <div class="form-block">
          <div class="form-block-inner" v-if="!teamMember.idTeamMember">
            <label>Full name</label>
            <input type="text" v-model="user.display_name">
          </div>
          <div class="form-block-inner" v-if="teamMember.idTeamMember">
            <label>Full name</label>
            <input type="text" v-model="teamMember.name">
          </div>
        </div>

        <div class="form-block form-block--locked ">
          <div class="form-block-inner">
            <label>Email</label>
            <input type="email" disabled v-model="user.email" >
          </div>
        </div>

        <template v-if="teamMember.idTeamMember">
          <div class="form-block">
            <div class="form-block-inner">
              <label>Phone</label>
              <input type="text" v-model="teamMember.phone">
            </div>
          </div>
          <div class="form-block">
            <div class="form-block-inner">
              <label>Linkedin</label>
              <input type="text" v-model="teamMember.linkedIn">
            </div>
          </div>
          <div class="form-block" v-if="!roles.length">
            <div class="form-block-inner">
              <label>Role</label>
              <input type="text" v-model="teamMember.role">
            </div>
          </div>
          <div class="form-block" v-if="roles.length">
            <div class="form-block-inner">
              <label>Role</label>
              <Selector
                  :id="`role`"
                  filterKey="role"
                  :selectorOptions="roles"
                  @change="val => teamMember.role = val[0].name"
              ></Selector>
            </div>
          </div>
          <div class="form-block">
            <div class="form-block-inner">
              <label>Specialty</label>
              <textarea v-model="teamMember.specialityArea"></textarea>
            </div>
          </div>
          <div class="form-block">
            <div class="form-block-inner">
              <label>Quote</label>
              <textarea v-model=teamMember.quotation></textarea>
            </div>
          </div>
          <div class="form-block">
            <div class="form-block-inner">
              <label>Country</label>
              <Selector
                  :id="`country`"
                  filterKey="country"
                  :selectorOptions="countries"
                  @change="val => teamMember.idCountry = val.id"
              ></Selector>
            </div>
          </div>
        </template>
      </div>
<!--        <div class="form-block" v-if="teamMember.idTeamMember">-->
<!--          <div class="form-block-inner">-->
<!--            <label>Linkedin</label>-->
<!--            <input type="text" v-model="profileData.li_profile">-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-block">-->
<!--          <div class="form-block-inner">-->
<!--            <label>Statement</label>-->
<!--            <RichEditor :init-value="profileData.statement" @change="changedStatement"></RichEditor>-->
<!--          </div>-->
<!--        </div>-->

      <div class="col-lg-12">
        <FieldSwitch v-for="field of fields" :field="field" :answers="answers" @changed="val => changeFields(val, field)" :key="field.idContentField"/>
      </div>
<!--      <div class="col-lg-5">-->
<!--        <span class="title">Company</span>-->
<!--        <div class="form-block">-->
<!--          <div class="form-block-inner">-->
<!--            <label>Global Practice</label>-->
<!--            <input type="text" v-model="profileData.global_practice">-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-block">-->
<!--          <div class="form-block-inner">-->
<!--            <label>Practice</label>-->
<!--            <input type="text" v-model="profileData.practice">-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-block">-->
<!--          <div class="form-block-inner">-->
<!--            <label>Client</label>-->
<!--            <input type="text" v-model="profileData.client">-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-block">-->
<!--          <div class="form-block-inner">-->
<!--            <label>Industry interests</label>-->
<!--            <input type="text" v-model="profileData.industry_interests">-->
<!--          </div>-->
<!--        </div>-->

<!--        <span class="title">Other</span>-->
<!--        <div class="form-block">-->
<!--          <div class="form-block-inner">-->
<!--            <label>Quote</label>-->
<!--            <RichEditor :init-value="profileData.quote" @change="changeQuote"></RichEditor>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-block">-->
<!--          <div class="form-block-inner">-->
<!--            <label>Hobbies</label>-->
<!--            <input type="text" v-model="profileData.hobbies">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="col-12 form-bottom">
        <a class="link" @click="$router.go(-1)"><span>Cancel</span></a>
        <button id="add-new-send" class="button-icon button-icon--send" @click="saveUser()">Update Profile</button>
      </div>
    </div>
    <Modal :show="showFlashMessage"
           @closeModal="showFlashMessage=false"
           :confirmButton="{}">
      <template v-slot:header>
        Your profile has been updated
      </template>
    </Modal>
  </div>
</template>

<script>
import api from '@/api/user'
import teamMemberApi from '@/api/teamMember'
import FieldSwitch from "@/components/forms/FieldSwitch";
import Modal from "@/components/general/Modal";
import ImageWrapper from "@/components/general/ImageWrapper.vue";
import ImageLoader from "@/components/forms/ImageLoader.vue";
import Selector from "@/components/forms/Selector.vue";
import settings from "@/settings";
export default {
  name: "ProfileForm",
  components: {Selector, ImageLoader, ImageWrapper, Modal, FieldSwitch},
  data() {
    return {
      profileData: {},
      uploading: false,
      loading: false,
      industries: null,
      fieldsChecked: {},
      user: JSON.parse(JSON.stringify(this.$store.getters.user)),
      showFlashMessage: false,
    }
  },
  mounted() {
    this.$store.dispatch('getTeamMember', this.$store.getters.user.idUser)
  },
  computed: {
    answers() {
      if(this.teamMember.idTeamMember) {
        return this.teamMember._embedded.Content._embedded.ContentFieldValue
      }
      return null
    },
    countries() {
      let countries = []
      this.$store.getters.countries.forEach(country => {
        countries.push(
            {
              id: country.idSettingGlobal,
              name: country.value,
              active: this.teamMember.idCountry === country.idSettingGlobal
            })
      })
      return countries
    },
    roles() {
      return this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.TEAM_MEMBER_ROLES).map(item => {
        return {
          id: item.idSettingCompany,
          name: item.value,
          active: this.teamMember.role === item.value
        }
      })
    },
    fields() {
      return this.$store.getters.getContentFieldForProfile
    },
    teamMember() {
      return JSON.parse(JSON.stringify(this.$store.getters.currentTeamMember))
    }
  },
  methods: {
    changedStatement(val) {
      this.profileData.statement = val;
    },
    changeQuote(val) {
      this.profileData.quote = val;
    },
    saveUser() {
      if(this.user.display_name !== this.$store.getters.user.display_name) {
        api.updateUserProfile({name: this.user.display_name}, () => {
          this.showFlashMessage = true
          this.$store.dispatch('getUserInfo', this.$store.getters.selectedCompanyId)
        })
      }
      if(this.teamMember.idTeamMember) {
        let  payload = {
          email: this.user.email,
          phone: this.teamMember.phone,
          linkedIn: this.teamMember.linkedIn,
          name: this.teamMember.name,
          role: this.teamMember.role,
          specialityArea: this.teamMember.specialityArea,
          quotation: this.teamMember.quotation,
          idCountry: this.teamMember.idCountry,
          contentFields: []
        }

        this.fields.forEach(field => {
          if(field.fieldType === 'CHOICE' && this.fieldsChecked[field.idContentField]) {
            payload.contentFields.push({
              idContentField: field.idContentField,
              values: this.fieldsChecked[field.idContentField].values
            })
          }
        })
        teamMemberApi.saveTeamMember(payload, () => {
          this.showFlashMessage = true
          this.$store.dispatch('getTeamMember', this.$store.getters.user.idUser)
        })
      }
      if(!this.teamMember.idTeamMember) {
        this.fields.forEach(field => {
          if(field.fieldType === 'CHOICE' && this.fieldsChecked[field.idContentField]) {
            let selected = this.fieldsChecked[field.idContentField]
            let fieldOptions = this.$store.getters.contentFieldOptionsForIdeaBoard(field.idContentField)
                .map(elem => elem.idContentFieldOption)
            let initValues = this.$store.getters.userContentFieldOptions
                .filter(elem => fieldOptions.includes(elem.idContentFieldOption))
                .map(elem => elem.idContentFieldOption)

            let toRemove = initValues.filter(id => {
              return !selected.ids.includes(id)
            })

            selected.ids = selected.ids.filter(id => {
              return !initValues.includes(id)
            })

            if(toRemove.length) {
              let b = this.$store.getters.userContentFieldOptions.filter(option => {
                return toRemove.includes(option.idContentFieldOption)
              }).map(elem => elem.idUserContentFieldOption)
              api.deleteUserContentFieldOption(b.join('.'), () => {
                this.showFlashMessage = true
                this.$store.dispatch('getUserInfo', this.$store.getters.selectedCompanyId)
              })
            }
            if(selected.ids.length) {
              let payload = {
                idUser: this.$store.getters.user.idUser,
                idContentFieldOption: selected.ids.join('.')
              }
              api.updateUserContentFieldOption(payload, () => {
                this.showFlashMessage = true
                this.$store.dispatch('getUserInfo', this.$store.getters.selectedCompanyId)
              })
            }
            if(!toRemove.length && !selected.ids.length) {
              this.showFlashMessage = true
            }
          }
        })
      }
    },
    uploadAvatar() {
      this.uploading = true;
      let file = this.$refs.file.files[0]
      api.updateUserPhoto(file, () => {
        this.$store.dispatch('getUserInfo', this.$store.getters.selectedCompanyId)
        this.uploading = false;
      })
    },
    changeFields(val, field) {
      this.fieldsChecked[field.idContentField] = val
    }
  }
}
</script>

<style scoped>

</style>
